import {
  InputProps as HeadlessInputProps,
  Input as HeadlessInput,
} from "@headlessui/react";
import React, { RefObject, FC } from "react";
import {
  RectangularFormField,
  type RoundFormFieldProps,
  RoundFormField,
  type StandardFormFieldProps,
  StandardFormField,
} from "@/components/FormFieldRendering";
import NumericInput from "../../NumericInput/NumericInput";

export type GenericTextualInputType =
  | "date"
  | "datetime-local"
  | "email"
  | "month"
  | "number"
  | "password"
  | "text"
  | "time"
  | "url"
  | "week";

export type GenericTextualInputProps = {
  type: GenericTextualInputType;
  ref?: RefObject<HTMLInputElement | null>;
} & (
  | ({
      variant: "form";
    } & Omit<StandardFormFieldProps<HeadlessInputProps>, "formControl">)
  | ({
      variant: "round";
    } & Omit<RoundFormFieldProps<HeadlessInputProps>, "formControl">)
  | ({
      variant: "rectangular";
    } & Omit<RectangularFormField<HeadlessInputProps>, "formControl">)
  | ({
      variant: "numeric";
    } & HeadlessInputProps)
  | ({
      variant: "unstyled";
    } & HeadlessInputProps)
);
/**
 * DO NOT USE!
 * USE THE FACADE COMPONENT `Input` INSTEAD.
 */
export const GenericTextualInput: FC<GenericTextualInputProps> = ({
  variant,
  ...props
}) => {
  switch (variant) {
    case "form":
      return (
        <StandardFormField<HTMLInputElement, HeadlessInputProps>
          className="w-full outline-none"
          formControl={HeadlessInput}
          withFixedLabel={[
            "color",
            "date",
            "datetime-local",
            "number",
            "time",
          ].includes(props.type)}
          {...props}
        />
      );
    case "round":
      return (
        <RoundFormField
          className="w-full px-4 py-4.5 outline-none"
          formControl={HeadlessInput}
          {...props}
        />
      );
    case "rectangular":
      return (
        <RectangularFormField
          className="w-full px-4 py-2 outline-none"
          formControl={HeadlessInput}
          {...props}
        />
      );
    case "numeric":
      return <NumericInput className="w-full outline-none" {...props} />;
    case "unstyled":
    default:
      return <HeadlessInput {...props} />;
  }
};
